export default "__VITE_ASSET__4f3d5829__"